import { adminHttpClient } from '../../commons/adminHttpClient'

export interface deleteCannedMessageData {
  id: string
}

const deleteCannedMessage = (dataToDelete: deleteCannedMessageData) => {
  return adminHttpClient.delete('/DocReview/CannedMessages', {
    data: dataToDelete,
  })
}

export default deleteCannedMessage
